export default "__VITE_ASSET__BH6rCVQ6__"